import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import { useNotification } from "../../../notification.hook";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { useEffect } from "react";
import { UpdatePathsGradesConfig } from "../../../../types/api/configurations.type";
import ConfigurationsPathsGradesService from "../../../../services/api/configurations/ConfigurationsPathsGrades.service";

const MANAGE_CONFIG_PATHS_GRADES_KEY = "get-config-paths-grades";

export const useManagePathsGrades = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: [MANAGE_CONFIG_PATHS_GRADES_KEY, configYear],
    queryFn: () => ConfigurationsPathsGradesService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching, refetch };
};

export const useUpdateManagePathsGrades = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: ["update-manage-paths-grades"],
    mutationFn: (result: UpdatePathsGradesConfig) =>
      ConfigurationsPathsGradesService.update(result),
    onSuccess: async () => {
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
      await queryClient.invalidateQueries({
        queryKey: [MANAGE_CONFIG_PATHS_GRADES_KEY],
      });
    },
    onError: (error) => {
      console.error(`error updating paths grades config: ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutate, mutateAsync, isPending };
};
